import React from 'react';
import { Link } from 'react-router-dom';

const Disclaimer = () => {
  return (
    <main className="min-h-screen relative pt-24 pb-24">
      {/* Ambient background glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-red-500/5 rounded-full blur-[120px] -z-10 pointer-events-none"></div>
      
      <section className="max-w-5xl mx-auto px-margin-mobile md:px-margin-desktop">
        
        {/* Breadcrumbs */}
        <div className="flex items-center space-x-2 text-[12px] text-on-surface-variant mb-12">
          <Link to="/" className="hover:text-red-500 transition-colors">Home</Link>
          <span>/</span>
          <span className="text-silver-text">Disclaimer</span>
        </div>

        {/* Header */}
        <div className="mb-16">
          <div className="bg-red-500/10 text-red-500 text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded inline-block mb-6 border border-red-500/20">
            Risk Disclosure
          </div>
          <h1 className="font-display-lg text-[48px] md:text-[64px] font-bold text-silver-text mb-4 leading-tight">
            Trading Risk <span className="text-red-500">Disclaimer</span>
          </h1>
          <p className="text-[14px] text-on-surface-variant">
            Last Updated: June 4, 2026
          </p>
        </div>

        {/* Content */}
        <div className="space-y-8 text-[14px] text-on-surface-variant leading-relaxed">
          
          {/* Main Warning Block */}
          <div className="bg-red-500/5 border border-red-500/20 rounded-2xl p-8">
            <div className="flex items-center text-red-500 text-[14px] font-bold uppercase tracking-widest mb-4">
              <span className="material-symbols-outlined mr-2">warning</span>
              High Risk Warning: Forex & CFD Trading
            </div>
            <p className="text-silver-text/90 leading-relaxed">
              Trading leveraged financial instruments, including Foreign Exchange (Forex) and Contracts for Difference (CFDs), carries an extremely high level of risk. Leveraged trading allows you to control larger positions with a relatively small deposit, which can amplify both profits and losses. You may experience a total loss of your initial deposit, or in some broker conditions, losses that exceed your account balance, requiring additional funding.
            </p>
          </div>

          {/* 2x2 Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            
            {/* Card 1 */}
            <div className="bg-[#1A1B20] border border-white/5 rounded-2xl p-8">
              <div className="flex items-center mb-4">
                <span className="text-xl mr-3">📉</span>
                <h3 className="text-[18px] font-bold text-silver-text">Past Performance Notice</h3>
              </div>
              <p>
                Any backtesting results, historical trade records, simulate performance metrics, or screenshots of live accounts displayed on Algo Forex EA represent historical analysis. Past performance is not a reliable indicator or guarantee of future trading success. Financial markets are continuously evolving, and historical trends may not repeat.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-[#1A1B20] border border-white/5 rounded-2xl p-8">
              <div className="flex items-center mb-4">
                <span className="text-xl mr-3">🔴</span>
                <h3 className="text-[18px] font-bold text-silver-text">No Profit Guarantees</h3>
              </div>
              <p>
                Algo Forex EA makes no representations, guarantees, warranties, or assurances that any Expert Advisor or indicator purchased will generate profits or prevent losses. Algorithmic trading systems operate on mathematical probabilities. Sudden economic events, news announcements, high spread expansions, or broker latency can lead to significant drawdown.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-[#1A1B20] border border-white/5 rounded-2xl p-8">
              <div className="flex items-center mb-4">
                <span className="text-xl mr-3">📚</span>
                <h3 className="text-[18px] font-bold text-silver-text">Educational & Informational Use</h3>
              </div>
              <p>
                All files, parameters, setfiles, and documentation delivered by Algo Forex EA are intended solely for educational, optimization testing, and informational purposes. None of the content provided on the Platform constitutes investment, financial, tax, or trading advice. You should seek independent advice from a certified financial advisor before trading with real capital.
              </p>
            </div>

            {/* Card 4 */}
            <div className="bg-[#1A1B20] border border-white/5 rounded-2xl p-8">
              <div className="flex items-center mb-4">
                <span className="text-xl mr-3">👤</span>
                <h3 className="text-[18px] font-bold text-silver-text">User Sole Responsibility</h3>
              </div>
              <p>
                You assume full responsibility for your trading activities and decisions. Algo Forex EA, its developers, operators, and affiliates shall not be liable for any trading losses, system outages, broker errors, VPS disconnections, margin calls, or account liquidations resulting from the deployment of any file acquired from the Platform.
              </p>
            </div>

          </div>

        </div>
      </section>
    </main>
  );
};

export default Disclaimer;
